<template>
    <div class="flash-messages">

        <template
            v-for="flashMessage in flashMessages"
        >
            <div
                :class="['message', ...flashMessage.type]"
                v-if="flashMessage.message"
                v-html="flashMessage.message"
            ></div>
        </template>

    </div>

</template>

<script setup>
import { useFlashMessagesStore } from '@jinkosoft/flash-messages'
import { onMounted } from 'vue';

const { flashMessages, processMessages } = useFlashMessagesStore()

onMounted(() => {
    processMessages()
})
</script>

<style lang="scss" scoped>

    .flash-messages {
        @apply fixed bottom-0 right-0 z-[1000000] mb-4 mr-4 min-w-[320px] max-w-[420px];

        .message {
            @apply m-3 rounded-2xl border px-4 py-3 text-base shadow-xl;
        }

        .message.cm-alert-success {
            @apply border-green-200 bg-green-50 text-green-800;
        }

        .message.cm-alert-info {
            @apply border-blue-200 bg-blue-50 text-blue-800;
        }

        .message.cm-alert-warning {
            @apply border-amber-200 bg-amber-50 text-amber-800;
        }

        .message.cm-alert-error,
        .message.cm-alert-danger {
            @apply border-red-200 bg-red-50 text-red-800;
        }
    }

</style>
